import React from 'react';


function NoPage() {
    return (
        <div className="page">
            <h1>
                Страница не найдена
            </h1>

            <h2>Код: <span>404</span></h2>
        </div>
    );
}

export default NoPage;